//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamGrafDefiniceDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-04-17                                                  </Created>
//  </FileHeader>

// tento script bude strojně generován podle XML předpisu definujícího SEZNAM

/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamGrafDefiniceDesigner
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamGrafDefiniceDesigner extends SeznamBase {

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GGrafDefiniceDto>;

        /**
         * SeznamGrafDefiniceDesignerInit
         * 
         * @param {GContentType<SeznamGrafDefiniceDesigner>} that
         */
        static SeznamGrafDefiniceDesignerInit(that: GContentType<SeznamGrafDefiniceDesigner>) {

            that.gridSearchColumns = "ixs_grf, nazev, aktivita, dat_zmena, zmenu_prov".split(",");

            this.SeznamBaseInit(that as GContentType<SeznamBase>);

            that.filter = this.createFilter(that);

            that.gridFormat = this.createGridFormat(that);

            that.view = new Gordic.Isl.View(that.isl.GrafDefinice.list(), { filterPanel: that.filter, startEmpty: false, });       // propojení ovládacího prvku gridu se zdrojem dat - a s filter panelem

        } // SeznamGrafDefiniceDesignerInit


        /** vytvořit formát seznamu - definice sloupců, napdpisů, šířek atd... */
        static createGridFormat(that: GContentType<SeznamGrafDefiniceDesigner>): Gordic.Data.GridFormat {

            var columnsDefinition = this.createGridFormatBase(that);

            columnsDefinition
                .addTextColumn({
                    name: "ixs_grf",
                    caption: "jres:32131027", //RC 32131027 : ID
                    width: 50,
                    fragment: ""
                })
                .addTextColumn({
                    name: "nazev",
                    caption: "jres:32131029", //RC 32131029 : Název
                    width: 500,
                    fragment: ""
                })

                .addTextColumn({
                    name: "aktivita_txt",
                    caption: "jres:32131030", //RC 32131030 : Aktivita
                    width: 150,
                    fragment: "seznam"
                })

                .addDateTimeColumn({
                    name: "dat_zmena",
                    caption: "jres:32131032", //RC 32131032 : Změněno
                    width: 150,
                    fragment: "*"
                })
                .addTextColumn({
                    name: "zmenu_prov",
                    caption: "jres:32131031", //RC 32131031 : Změnil
                    width: 150,
                    fragment: ""
                })

            return columnsDefinition;
        } // createGridFormat

        /** vytvořit formulář filtru - panel */
        static createFilter(that: GContentType<SeznamGrafDefiniceDesigner>): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = this.createFilterBase(that, v_form, true);

            return (v_filter);
        } // createFilter

        /** vytvořit formulář filtru - vytvoří tam filtrační políčka */
        static createFilterForm(that: GContentType<SeznamGrafDefiniceDesigner>): Forms.Form {

            // vytvořím form
            var v_filterForm = this.createFilterFormBase(that);
            return v_filterForm;
        } // createFilterForm
    }


}